<mat-chip-listbox
    class="community-map__filters"
    multiple
    i18n-aria-label="@@filter-label-locations"
    aria-label="Filter locations"
    (change)="selectionChanged($event)">
    <mat-chip-option
        *ngFor="let button of buttons"
        tabindex="0"
        aria-label="{{ button.text }}"
        title="{{ button.text }}"
        id="{{ button.id }}"
        value="{{ button.id }}"
        class="riege-chips">
        <mat-icon class="riege-icon" matChipAvatar>{{ button.icon }}</mat-icon>
        <span *ngIf="isMobile()">
            <span *ngIf="button.id === selectedID">
                <span class="is-active">{{ button.text }}</span>
            </span>
        </span>
        <span *ngIf="!isMobile()"> {{ button.text }} </span>
    </mat-chip-option>
</mat-chip-listbox>
